// extracted by mini-css-extract-plugin
module.exports = {"create-staff-form":"CreateStaffForm_create-staff-form__bzKvn","footer":"CreateStaffForm_footer__jAEFN","select":"CreateStaffForm_select__3Ow8f"};